export default __webpack_public_path__ + "0309f44619538eac57555d0789af1b9a.png";